import React from 'react';
import Banner from '../components/common/Banner';

const VisionMissionPage = () => {
  return (
    <div className="bg-white">
      {/* Hero Banner */}
      <Banner 
        title="Vision & Mission" 
        subtitle="Shaping the future through excellence in education and innovation"
        imageSrc="https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
      />
      
      {/* Main Content */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6 md:px-8">
          
          {/* Vision Section */}
          <div className="bg-white rounded-xl shadow-soft p-12 md:p-16 mb-12">
            <div className="grid md:grid-cols-3 gap-12">
              {/* Image Placeholder */}
              <div className="md:col-span-1">
                <div className="bg-white rounded-lg aspect-[4/3] flex items-center justify-center mb-6 border-2 border-gray-200">
                  <div className="text-center">
                    <i className="fas fa-eye text-6xl text-crimson mb-3"></i>
                    <p className="text-xs text-gray-500 uppercase tracking-wide">Vision Image</p>
                  </div>
                </div>
              </div>
              
              {/* Vision Content */}
              <div className="md:col-span-2">
                <h2 className="text-3xl md:text-4xl font-serif font-bold text-crimson mb-6">Our Vision</h2>
                <div className="space-y-4">
                  <p className="text-gray-600 leading-relaxed text-lg">
                    To be a premier institute of technology that empowers students to become innovative leaders and ethical professionals who contribute meaningfully to society and the global economy.
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    We envision FiT Engineering College as a center of excellence that bridges the gap between academic knowledge and industry requirements, fostering a culture of research, innovation, and entrepreneurship.
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    Our vision extends beyond traditional education to create well-rounded individuals who possess not only technical expertise but also strong ethical values, leadership qualities, and a commitment to sustainable development.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Mission Section */}
          <div className="bg-white rounded-xl shadow-soft p-12 md:p-16 mb-12">
            <div className="grid md:grid-cols-3 gap-12">
              {/* Mission Content */}
              <div className="md:col-span-2">
                <h2 className="text-3xl md:text-4xl font-serif font-bold text-crimson mb-6">Our Mission</h2>
                <div className="space-y-4">
                  <p className="text-gray-600 leading-relaxed text-lg">
                    To provide world-class technical education that combines theoretical knowledge with practical application, preparing students for successful careers in an ever-evolving technological landscape.
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    We are committed to:
                  </p>
                  <ul className="list-disc list-inside text-gray-600 leading-relaxed space-y-2 ml-4">
                    <li>Delivering innovative and industry-relevant curriculum that meets global standards</li>
                    <li>Fostering research and development activities that contribute to technological advancement</li>
                    <li>Creating an inclusive learning environment that promotes creativity and critical thinking</li>
                    <li>Building strong partnerships with industry leaders and academic institutions worldwide</li>
                    <li>Developing responsible citizens who contribute to society's welfare and sustainable development</li>
                    <li>Encouraging entrepreneurship and innovation among students and faculty</li>
                  </ul>
                </div>
              </div>
              
              {/* Image Placeholder */}
              <div className="md:col-span-1">
                <div className="bg-white rounded-lg aspect-[4/3] flex items-center justify-center mb-6 border-2 border-gray-200">
                  <div className="text-center">
                    <i className="fas fa-bullseye text-6xl text-crimson mb-3"></i>
                    <p className="text-xs text-gray-500 uppercase tracking-wide">Mission Image</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Core Values Section */}
          <div className="bg-white rounded-xl shadow-soft p-12 md:p-16">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-crimson mb-8 text-center">Our Core Values</h2>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="bg-crimson/10 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-star text-3xl text-crimson"></i>
                </div>
                <h3 className="font-bold text-lg text-slate mb-2">Excellence</h3>
                <p className="text-sm text-gray-600">Striving for the highest standards in everything we do</p>
              </div>
              
              <div className="text-center">
                <div className="bg-crimson/10 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-lightbulb text-3xl text-crimson"></i>
                </div>
                <h3 className="font-bold text-lg text-slate mb-2">Innovation</h3>
                <p className="text-sm text-gray-600">Encouraging creative thinking and pioneering solutions</p>
              </div>
              
              <div className="text-center">
                <div className="bg-crimson/10 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-heart text-3xl text-crimson"></i>
                </div>
                <h3 className="font-bold text-lg text-slate mb-2">Integrity</h3>
                <p className="text-sm text-gray-600">Upholding honesty and ethical practices in all endeavors</p>
              </div>
              
              <div className="text-center">
                <div className="bg-crimson/10 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-users text-3xl text-crimson"></i>
                </div>
                <h3 className="font-bold text-lg text-slate mb-2">Collaboration</h3>
                <p className="text-sm text-gray-600">Working together to achieve common goals and success</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default VisionMissionPage;